import {
  OutlinedButton,
} from "@components/atoms/base-button/index";
import { BannerProps } from "@models/types/banner.inteface";
import classNames from "classnames";
import { handleClick } from "../utils/scroll-down";

export function AcreaBanner(props: BannerProps) {
  const {
    title,
    text,
    cta,
    img,
    bannerHeight,
    textBackgroundClass,
    alt,
    withFadeBackground = true,
  } = props;
  return (
    <div
      className={`w-full overflow-hidden relative flex xs:items-center s:items-start lg:items-center justify-center lg:justify-start ${bannerHeight} `}
    >
      <img
        src={img}
        className="absolute top-0 left-0 w-full h-full object-cover bg-no-repeat bg-cover bg-center "
        alt={alt ?? ""}
      />
      <div
        className={classNames(
          "relative  lg:h-[79%] lg:w-1/2 lg:min-w-[660px] flex flex-col justify-center items-end m-5 lg:m-0",
          { "bg-white/80": withFadeBackground },
          { textBackgroundClass }
        )}
      >
        <div className="flex flex-col gap-y-[22px] lg:m-12 mx-5 my-[50px] text-left justify-center">
          <h1 className="max-sm:text-[35px] lg:text-[65px] lg:w-[580px] font-chivo-bold-italic leading-none mb-4">
            {title}
          </h1>
          <p className="mb-4 max-sm:text-lg font-chivo-regular lg:w-[558px]">
            {text}
          </p>
          <OutlinedButton className="w-[300px] h-[60px] bg-transparent" onClick={() => handleClick("bundle-product")}>
            {cta}
          </OutlinedButton>
        </div>
      </div>
    </div>
  );
}
